// extracted by mini-css-extract-plugin
export default {"fields":"XU7TWr","gaps":"eQBRLG","time":"w0q9gp","mobile":"zLC2J2"};